var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"panorama-iframe",attrs:{"src":_vm.src,"scrolling":"no","frameborder":"0","allowTransparency":"true","seamless":""}})}
var staticRenderFns = []

export { render, staticRenderFns }